import _ from 'lodash';
import {fromJS} from 'immutable';
import {combineReducers} from 'redux-immutable';

import paginatorReducer from '../../paginator/reducer';
import treeReducer from '../tree/reducer';
import Book from './component';
import mainReducer from './reducer';


export const initialState = {elementId: 'book'};

const _reducer = combineReducers({
    main: mainReducer,
    gradeTree: treeReducer,
    categoryTree: treeReducer,
    compilersTree: treeReducer,
    coworkersTree: treeReducer,
    editorsTree: treeReducer,
    printTypeTree: treeReducer,

    users: paginatorReducer,
    regionsTreeFilter: treeReducer,
    citiesTreeFilter: treeReducer,

    examinations: paginatorReducer,

    noteTypeTree: treeReducer,
});

export const reducer = (state, action) => {
    if (!state.get('gradeTree')) {
        const id = state.get('elementId');
        const printTypes = _.mapKeys(_.map(Array(3), (__, index) =>
            ({id: index + 1, label: window.pgettext('book:print-type', index + 1)})), value => value.id);
        state = fromJS({
            main: {elementId: id},
            gradeTree: {elementId: id + ':gradeTree'},
            categoryTree: {elementId: id + ':categoryTree'},
            compilersTree: {elementId: id + ':compilersTree'},
            coworkersTree: {elementId: id + ':coworkersTree'},
            editorsTree: {elementId: id + ':editorsTree'},
            printTypeTree: {
                elementId: id + ':printTypeTree',
                staticItems: printTypes,
            },
        });
    }
    return _reducer(state, action);
};

export const component = Book;
window.pgettext('book:print-type', '1');
window.pgettext('book:print-type', '2');
window.pgettext('book:print-type', '3');
